// AUTO-GENERADO por scripts/gen-icon-registry.mjs — no editar a mano.
// Sólo los nombres: lo que app-icon necesita de forma síncrona para decidir si un icono
// va por el sprite (ICON_SLUGS) o como <img> (ICON_IMG). El contenido de los símbolos
// vive en icon-registry.ts y se carga con import() sólo si el sprite del HTML no lo trae.
export const ICON_SLUGS = new Set<string>([
  "ionicons/alert",
  "ionicons/caret-down-outline",
  "ionicons/chevron-down-outline",
  "ionicons/chevron-forward-outline",
  "ionicons/chevron-up-outline",
  "ionicons/clipboard-outline",
  "ionicons/close",
  "ionicons/close-outline",
  "ionicons/ellipse-sharp",
  "ionicons/ellipsis-vertical-sharp",
  "ionicons/expand-outline",
  "ionicons/eye-off-outline",
  "ionicons/eye-outline",
  "ionicons/link-outline",
  "ionicons/options-outline",
  "ionicons/pin",
  "ionicons/pin-outline",
  "message/image",
  "message/link",
  "message/link_grey",
  "message/sticker",
  "new_design/adult_forbidden",
  "new_design/alert_circle",
  "new_design/arrow_down",
  "new_design/arrow_left",
  "new_design/arrow_right",
  "new_design/arrow_right_outline",
  "new_design/bell",
  "new_design/bookmark",
  "new_design/briefcase",
  "new_design/calendar",
  "new_design/calendar_outline",
  "new_design/car_shipping",
  "new_design/caret_right_outline",
  "new_design/chat",
  "new_design/chat_dots",
  "new_design/check",
  "new_design/checkbox",
  "new_design/checkmark",
  "new_design/chevron_down",
  "new_design/chevron_right",
  "new_design/chevron_right_double",
  "new_design/clock_fill",
  "new_design/color_palette",
  "new_design/community",
  "new_design/company",
  "new_design/company_filled",
  "new_design/cookie_bite",
  "new_design/coupon",
  "new_design/discount_tag",
  "new_design/eye_off",
  "new_design/eye_preview",
  "new_design/facebook",
  "new_design/fire",
  "new_design/gmail",
  "new_design/heart_down",
  "new_design/heart_up",
  "new_design/heart_up_outline",
  "new_design/help",
  "new_design/category",
  "new_design/user",
  "new_design/home",
  "new_design/image",
  "new_design/instagram",
  "new_design/law",
  "new_design/legal",
  "new_design/linkedin",
  "new_design/menu",
  "new_design/minus",
  "new_design/moon",
  "new_design/options",
  "new_design/para_ti",
  "new_design/pencil",
  "new_design/person",
  "new_design/phone",
  "new_design/plus",
  "new_design/plus_circle",
  "new_design/popular_arrow",
  "new_design/quote",
  "new_design/refresh",
  "new_design/refresh_outline",
  "new_design/scissors",
  "new_design/search",
  "new_design/send",
  "new_design/share",
  "new_design/share_2",
  "new_design/skull",
  "new_design/speedometer_up_outline",
  "new_design/spin",
  "new_design/square_arrow-no-filter",
  "new_design/star",
  "new_design/star_10",
  "new_design/sun",
  "new_design/tag",
  "new_design/text",
  "new_design/thumbs_down",
  "new_design/thumbs_up",
  "new_design/thumbs_up_outline",
  "new_design/toolbar_compact",
  "new_design/toolbar_default",
  "new_design/toolbar_grid",
  "new_design/trash",
  "new_design/trophy",
  "new_design/twitter",
  "new_design/upload",
  "new_design/warning-oct-filled",
  "new_design/warning-outline",
  "new_design/warning_circle_filled",
  "new_design/x",
  "new_design/youtube",
  "sandglass",
  "time"
]);

export const ICON_IMG = new Set<string>([
  "arrow",
  "chat",
  "comment",
  "message/like",
  "new_design/amazon_prime",
  "new_design/app_store_text",
  "new_design/apple",
  "new_design/google_play",
  "new_design/google_play_text",
  "new_design/mail_outline",
  "new_design/michollo_logo_square",
  "new_design/share/messenger",
  "new_design/square_arrow",
  "new_design/trustpilot_stars",
  "new_design/warning-oct-outline",
  "plus",
  "settings/settings",
  "tag",
  "trust"
]);
